const CONSENT_COOKIE = 'cc_consent';
const CONSENT_VALUE = 'accepted';
const MAX_AGE_DAYS = 365;

/** Try to set, read, and delete a test cookie. Returns false if cookies are blocked. */
export function areCookiesEnabled(): boolean {
  try {
    document.cookie = '__cookie_test=1; SameSite=Lax; path=/';
    const ok = document.cookie.includes('__cookie_test=1');
    document.cookie = '__cookie_test=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    return ok;
  } catch {
    return false;
  }
}

/** Check if the user has already accepted cookies. */
export function hasConsent(): boolean {
  return document.cookie
    .split('; ')
    .some((c) => c === `${CONSENT_COOKIE}=${CONSENT_VALUE}`);
}

/** Write the consent cookie (365 days, SameSite=Lax, Secure in prod). */
export function setConsent(): void {
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${CONSENT_COOKIE}=${CONSENT_VALUE}; max-age=${maxAge}; SameSite=Lax; path=/${secure}`;
}
